/**
 * InlineSubtaskRow Component
 * Inline expandable subtask list for table rows
 */
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { fetchSubtasks } from '../../store/ticketSlice';
import { COLORS } from '../../shared/colors';
import NestedSubtask from './NestedSubtask';

const InlineSubtaskRow = ({ task, isExpanded }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [localSubtasks, setLocalSubtasks] = useState([]);


  React.useEffect(() => {
    const handleExpansion = async () => {
      if (isExpanded && localSubtasks.length === 0) {
        setIsLoading(true);
        try {
          const result = await dispatch(fetchSubtasks(task.id)).unwrap();
          setLocalSubtasks(result);
        } catch (error) {
          console.error('Failed to fetch subtasks:', error);
        } finally {
          setIsLoading(false);
        }
      }
    };
    handleExpansion();
  }, [isExpanded, task.id, dispatch, localSubtasks.length]);

  return (
    <Collapse in={isExpanded} timeout={300}>
      <Box sx={{ 
        p: 2,
        bgcolor: COLORS.blue[25],
        borderTop: `1px solid ${COLORS.blue[100]}`
      }}>
        {isLoading ? (
          <Typography sx={{ fontSize: '12px', color: COLORS.gray[500] }}>
            {t('dashboard.loadingSubtasks')}
          </Typography>
        ) : (
          <>
            <Typography sx={{ 
              fontSize: '11px', 
              fontWeight: 600, 
              color: COLORS.blue[700],
              mb: 1.5,
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}>
              {localSubtasks.length} Subtasks
            </Typography>
            <Box sx={{ display: 'grid', gap: 1 }}>
              {localSubtasks.map((subtask) => (
                <NestedSubtask 
                  key={subtask.id} 
                  subtask={subtask} 
                  level={0}
                  variant="row"
                />
              ))}
            </Box>
          </>
        )}
      </Box>
    </Collapse>
  );
};

export default InlineSubtaskRow;